export function reinsertScripts(root: HTMLElement): void {
    const scripts = Array.from(root.querySelectorAll("script"));

    for (const oldScript of scripts) {
        const newScript = document.createElement("script");

        // Copy attributes (src, type, async, data-*, etc)
        for (const attr of Array.from(oldScript.attributes)) {
            newScript.setAttribute(attr.name, attr.value);
        }

        // Copy inline script content
        if (oldScript.textContent) {
            newScript.textContent = oldScript.textContent;
        }

        // Replace to trigger execution
        oldScript.parentNode?.replaceChild(newScript, oldScript);
    }
}
